export enum PersonCheckerType {
    parent = 'Parent',
    child = 'Child',
  }